import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { usePmsJobType, PmsJobType } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<PmsJobType>
    useData={usePmsJobType}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
